import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { call, countryArr, QR } from "../../assets/img";
import { URLS } from "../../Services/Constant";
import { get, post, put } from "../../Services/ApiHandler";
import "react-international-phone/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import Loader from "../../Component/Loader";
import countryData from "../../Services/CountryData.json";
import useStoreKv from "../redux/store/useStorekv";
import { Toast } from "../../Component/Toast";
import CustomScroll from "../../Component/CustomScroll";

const ClientReport = () => {


  const { kv, set } = useStoreKv();
  const ClientView = kv.clientview || [];
  const location = useLocation();
  const type = location?.state?.type;
  const data = location?.state?.data;


  const localData = data?.client_id === ClientView?.clientID;

//   console.log("localData", localData);


  const navigate = useNavigate();

  const [errors, setErrors] = useState({});
  const [popup, setPopup] = useState(false);
  const [Remove, setRemove] = useState(false);
  const [countryCode, setCountryCode] = useState("+91");
  const [isValidForm, setIsValidForm] = useState(false);
  const [isValidForm2, setIsValidForm2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false)
  const [Addpopup, setAdd] = useState(false);
  const [UnblockUser, setUnblock] = useState(false);
  const [qrImage, setQrImage] = useState(null);
  const [load, setLoad] = useState(false);
  const [load2, setLoad2] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(countryData.find(c => c.iso === 'IN') || countryData[0]);
  const [isLoading, setIsLoading] = useState(false);
  const [updateUser, setUpdateUser] = useState(false);

  const [showPopup, setShowPopup] = useState(false);
  const [showPopupImage, setShowPopupImage] = useState(null);

//   console.log("data client report", data);

  const [resetData, setResetData] = useState(false)
  const maxLength = selectedCountry?.maxLength;
  const [deleteStatus, setDeleteStatus] = useState(null);
  const [formData, setFormData] = useState(
    localData ? ClientView :
      {
        client: "",
        Clientname: "",
        mobile: '',
        Wallet: "",
        history: "",
        empty: "",
        anountno: "",
        ifsc: "",
        upi: "",
        clientID: "",
        block_reason: "",
        status: '',
      });



  const getList = async () => {
    const postID = data?.client_id || data?.client_id;

    if (!postID) return;

    try {
      if (!kv.clientview || kv.clientview.length === 0) {
        setLoading(true);
      }
      const res = await get(`${URLS.CLIENT}/${postID}`)
//       console.log("Fetched client:", res);

      if (res?.status === "success") {
        if (res?.data?.bank_details?.acc_no) {
          setIsValidForm(true)
        }
        if (res?.data?.bank_details?.qrcode) {
          setIsValidForm2(true);
        }

        setFormData({
          clientID: res?.data?.client_id,
          Clientname: res?.data?.name,
          // mobile: res?.data?.mobile ? `${data.country_code || "+91"}${data.mobile}` : "",
          mobile: res?.data?.mobile,
          Wallet: res?.data?.wallet_amount,
          history: res?.data?.team_size,
          status: res?.data?.status,
          anountno: res?.data?.bank_details?.acc_no,
          ifsc: res?.data?.bank_details?.ifsc_code,
          upi: res?.data?.bank_details?.upi_id,
          accountholder: res?.data?.bank_details?.acc_holder,
        });
        set('clientview', {
          clientID: res?.data?.client_id,
          Clientname: res?.data?.name,
          // mobile: res?.data?.mobile ? `${data.country_code || "+91"}${data.mobile}` : "",
          mobile: res?.data?.mobile,
          Wallet: res?.data?.wallet_amount,
          history: res?.data?.team_size,
          status: res?.data?.status,
          anountno: res?.data?.bank_details?.acc_no,
          ifsc: res?.data?.bank_details?.ifsc_code,
          upi: res?.data?.bank_details?.upi_id,
          accountholder: res?.data?.bank_details?.acc_holder,
        });
        setQrImage(res?.data?.bank_details?.qrcode);
      } else {
        Toast(res?.message || "No data found");
        set('clientview', {});
      }

    } catch (err) {
      console.error("Error fetching role list:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (type === "edit") getList();
  }, [data?.client_id, type]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validatePhone = (value, countryCode = "IN") => {
    const phoneNumber = parsePhoneNumberFromString(value, countryCode);
    return phoneNumber ? phoneNumber.isValid() : false;
  };


  const handlePhoneChange = (value, data) => {
    const cleanValue = value.replace(/[-\s]/g, "");
    setFormData((prev) => ({ ...prev, mobile: cleanValue }));
    if (data?.country?.dialCode) {
      setCountryCode(`+${data?.country?.dialCode}`);
    }
  };

  const handleCountrySelect = (country) => {
    setFormData((prev) => ({ ...prev, mobile: '' }));
    setSelectedCountry(country);
    setCountryCode(country.code);
    setDropdownOpen(false);
  };

  const validate = () => {
    let newErrors = {};

    if (!formData?.Clientname) {
      newErrors.Name = "Name is required";
    }

    // if (!formData?.mobile) {
    //   newErrors.mobile = "Mobile number is required";
    // } else if (!validatePhone(formData?.mobile, countryCode)) {
    //   newErrors.mobile = "Enter a valid phone number";
    // }

    // if (!formData.Password) {
    //   newErrors.Password = "Password is required";
    // } else if (formData.Password.length < 6) {
    //   newErrors.Password = "Password must be at least 6 characters";
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };



  const handleSubmit = async () => {
//     console.log('formData faa', formData)
    if (!validate()) return;

    const cleanMobile = formData.mobile.replace(countryCode, "").replace(/[^\d]/g, "");

    const finalData = {
      name: formData?.Clientname,
      mobile: cleanMobile,
      country_code: countryCode,
    };

    try {
      setIsLoading(true);
      const res = await put(`${URLS.CLIENT}/${data?.client_id}`, finalData)
//       console.log("Fetched update client:", res);
      if (res?.status === "success") {
        setUpdateUser(false);
      }
    } catch (err) {
      console.error("Error fetching role list:", err);
    } finally {
      setIsLoading(false);
      setUpdateUser(false);
    }

  };
//   console.log("formData?.clientID", formData?.clientID);


  const handleDeleteBank = async () => {

    let posts;
    if (deleteStatus) {

      posts = 'bank-details/delete-qr'
    } else {
      posts = `bank-details/delete`
    }
    try {
      if (deleteStatus) { setLoad(true) } else { setLoad2(true) }
      const res = await post(`${URLS.CLIENT}/${data?.client_id}/${posts}`);
//       console.log("delete bank details success:", res);
      if (res?.status === "success") {
        setFormData((prev) => ({
          ...prev,
          anountno: "",
          ifsc: "",
          upi: "",
          accountholder: "",
        }));
        setIsValidForm(false);
        setResetData(false)
        getList();
      }
    } catch (err) {
      console.error("Error fetching role list:", err);
    } finally {
      if (deleteStatus) { setLoad(false) } else { setLoad2(false) }
      setResetData(false)
    }
  }

  const handleBlock = async (status) => {

//     console.log("data?.client_id", data?.client_id);

    const payload = {
      block_reason: formData?.block_reason,
    };

    try {
      setLoader(true);

      const changeStatus = status === 'Blocked' ? 'block' : 'unblock';
      const res = await post(`${URLS.CLIENT}/${data?.client_id}/${changeStatus}`, payload);

//       console.log("Block/unblock success:", res);

      if (res?.status === "success") {
        if (status === 'Blocked') {
          setPopup(false);
        } else {
          setUnblock(false)
        }
        getList();
      } else {
        console.error("Failed to change block status:", res);
      }
    } catch (err) {
      console.error("Error during block/unblock:", err);
    } finally {
      setLoader(false);
    }
  };

  const handleAddAmount = async (type) => {
    const posts = {
      client_id: formData?.clientID,
      amount: formData.empty,
      type: type,
    }

    try {
      setLoad(true);
      const res = await post(`${URLS.CLIENTAMOUNTADD}`, posts);
//       console.log("amount post", res);
      if (res?.status === "success") {
        setAdd(false);
        setRemove(false)
        setFormData((prev) => ({ ...prev, empty: "" }));
        getList();

      }
    } catch (err) {
      console.error("Error fetching:", err);
    } finally {
      setLoad(false);
    }

  }

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/[^\d]/g, '');
    if (value.length <= maxLength) {
      setFormData((prev) => ({ ...prev, mobile: value }));
      setErrors(prev => ({ ...prev, mobile: "" }));
    }
  };

//   console.log("formData.empty", formData.empty);


  return (
    <div className="dashRightView ">
      <CustomScroll>
        <div style={{ paddingTop: 0 }} className="container_overalls  col-md-5">
          <div className="col-md-5 my-3">
            <label className="form-label f2 fs-md-14 fs-lg-16 m-0 primary1">
              Client ID
            </label>
            <input
              className="input-box f2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-15 fs-xxl-20 placholdercolorchanges2"
              name="clientID"
              style={{ color: '#575757' }}
              value={formData.clientID}
              onChange={handleChange}
              type="text"
              placeholder="Client ID"
              disabled
            />
            {errors.clientID && <p className="err">{errors.clientID}</p>}
          </div>
          <div className="col-md-5 my-3">
            <div className="d-flex ac-js">
              <label className="form-label f2 fs-md-14 fs-lg-16 m-0 primary1">
                Client Name
              </label>
            </div>
            <input
              className=" placholdercolorchanges2 input-box f2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-15 fs-xxl-20"
              name="Clientname"
              value={formData.Clientname}
              onChange={handleChange}
              type="text"
              placeholder="Enter Client Name"
            />
            {errors.Clientname && <p className="err">{errors.Clientname}</p>}
          </div>
          <div className="form-group  text-start my-3">

            {/* PHONE INPUT */}
            <div className="form-group col-md-5 text-start">
              <label className="form-label f2 fs-md-14 fs-lg-16 m-0 primary1">
                Mobile Number
              </label>
              <div
                className="login-input mt-1"
                style={{
                  height: 50,
                  background: "#F0EDE6",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: 8,
                  position: 'relative',
                }}
              >
                {/* Country Code Button */}
                <button
                  type="button"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  style={{
                    backgroundColor: '#6E6E6E',
                    border: '1px solid #00474366',
                    color: '#ffffff',
                    fontSize: 16,
                    width: 60,
                    height: 50,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 4,
                    cursor: 'pointer',
                    borderRadius: '8px 0 0 8px',
                    position: 'relative',
                    padding: "0 34px",
                  }}
                >
                  <img src={countryArr} alt="country dropdown arrow" style={{ width: 15, height: 9 }} />
                  {selectedCountry.code}
                </button>

                {/* Phone Input */}
                <input
                  type="number"
                  placeholder="Mobile Number"
                  value={formData?.mobile}
                  onChange={handleMobileChange}
                  className="placholdercolorchanges2"
                  style={{
                    flex: 1,
                    border: 'none',
                    outline: 'none',
                    backgroundColor: 'transparent',
                    fontSize: 16,
                    color: '#1B1B1B',
                    padding: '0 10px',
                    height: 50,
                  }}
                />

                <img src={call} alt="call icon" style={{ marginRight: 12, width: 20, top: 1, position: 'relative' }} />

                {/* Dropdown */}
                {dropdownOpen && (
                  <div
                    style={{
                      position: 'absolute',
                      top: 52,
                      left: 0,
                      right: 0,
                      backgroundColor: '#ffffff',
                      border: '1px solid rgb(0 71 67 / 40%)',
                      borderRadius: 8,
                      maxHeight: 200,
                      overflowY: 'auto',
                      zIndex: 1000,
                    }}
                  >
                    {countryData.map((country) => (
                      <div
                        key={country.iso}
                        onClick={() => handleCountrySelect(country)}
                        style={{
                          padding: '10px',
                          cursor: 'pointer',
                          borderBottom: '1px solid rgb(0 71 67 / 40%)',
                          backgroundColor: selectedCountry.iso === country.iso ? '#ffffff' : '#F0EDE6',
                        }}
                      >
                        {country.name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {errors.mobile && <p className="err">{errors.mobile}</p>}
            </div>


            <div className=" my-3">
              <button
                onClick={() => setUpdateUser(true)}
                className="add-button f3  fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 white"
              >Update User
              </button>
            </div>
          </div>
          <div className="form-group col-md-5 text-start my-3">
            <label className="form-label f2 fs-md-14 fs-lg-16 m-0 primary1">
              Wallet Balance
            </label>
            <div className="login-input2  mt-1">
              <input
                className="placholdercolorchanges2 f2 fs-xs-16 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-15 fs-xxl-20"
                name="Wallet"
                value={formData.Wallet}
                onChange={handleChange}
                type="text"
                placeholder="Wallet Balance"
                disabled
              />
              <p
                onClick={() => {
                  if (formData?.clientID) {
                    navigate("/wallet-history", { state: { clientId: formData.clientID } });
                  } else {
                    console.warn("Client ID is missing");
                  }
                }}
                className="f3 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18 cursor-pointer"
              >
                View History
              </p>
              {errors.Wallet && <p className="err">{errors.Wallet}</p>}
            </div>
          </div>
          <div className="form-group col-md-5 text-start my-3">
            <div className="login-input  mt-3">
              <input
                className="placholdercolorchanges2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-15 fs-xxl-20"
                name="empty"
                value={formData.empty}
                onChange={handleChange}
                type="number"
                placeholder="Enter Amount"
                onInput={(e) => {
                  if (e.target.value.length > 11) {
                    e.target.value = e.target.value.slice(0, 11);
                  }
                }}
              />
              {errors.empty && <p className="err">{errors.empty}</p>}
            </div>
          </div>
          <div className="removeAddBtn my-3 d-flex ac-jb">
            <button
              disabled={!formData.empty}
              onClick={() => setRemove(true)}
              className="remove-button f3  fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 "
            >
              Remove
            </button>
            <button
              onClick={() => setAdd(true)}
              className="Add-Button f3  fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19   "
              disabled={!formData.empty}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                minHeight: 48,
                backgroundColor: !formData.empty ? '#9BBFBC' : '#004743',
                border: !formData.empty ? "1px solid #9BBFBC" : "1px solid #004743"
              }}
            >
              Add
            </button>
          </div>
          <div className="form-group col-md-5 text-start my-3">
            <label className="form-label f2 fs-md-14 fs-lg-16 m-0 primary1">
              Team Size
            </label>
            <div className="login-input2  mt-1">
              <input
                className="placholdercolorchanges2 f2 fs-xs-16 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-15 fs-xxl-20"

                name="userName"
                value={formData.history}
                onChange={handleChange}
                type="text"
                placeholder="0"
                disabled
              />
              <p
                onClick={() => {
                  if (formData?.clientID) {
                    navigate("/team-size", { state: { clientId: formData.clientID } });
                  } else {
                    console.warn("Client ID is missing");
                  }
                }}
                className="f3 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18 cursor-pointer"
              >
                View Team
              </p>
            </div>
            {errors.history && <p className="err">{errors.history}</p>}
          </div>
          <div className="col-md-5 my-3">
            <label className="form-label f2 fs-md-14 fs-lg-16 m-0 primary1">
              Account Number
            </label>
            <input
              className="placholdercolorchanges2 input-box f2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-15 fs-xxl-20"
              name="anountno"
              style={{ color: '#5e5e5e' }}
              value={formData.anountno}
              onChange={handleChange}
              type="text"
              placeholder="Account number is not added"
              disabled
            />
            {errors.anountno && <p className="err">{errors.anountno}</p>}
          </div>{" "}
          <div className="col-md-5 my-3">
            <label className="form-label f2 fs-md-14 fs-lg-16 m-0 primary1">
              IFSC Code
            </label>
            <input
              className="placholdercolorchanges2 input-box f2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-15 fs-xxl-20"
              name="ifsc"
              value={formData.ifsc}
              style={{ color: '#5e5e5e' }}
              onChange={handleChange}
              type="text"
              placeholder="IFSC code is not added"
              disabled
            />
            {errors.ifsc && <p className="err">{errors.ifsc}</p>}
          </div>{" "}
          <div className="col-md-5 my-3">
            <label className="form-label f2 fs-md-14 fs-lg-16 m-0 primary1">
              Account Holder Name
            </label>
            <input
              className="placholdercolorchanges2 input-box f2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-15 fs-xxl-20"
              name="accountholder"
              value={formData.accountholder}
              onChange={handleChange}
              style={{ color: '#5e5e5e' }}
              type="text"
              placeholder="Account holder name is not added"
              disabled
            />
            {errors.accountholder && (
              <p className="err">{errors.accountholder}</p>
            )}
          </div>{" "}
          <div className="col-md-5 my-3">
            <label className="form-label f2 fs-md-14 fs-lg-16 m-0 primary1">
              UPI ID
            </label>
            <input
              className="placholdercolorchanges2 input-box f2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-15 fs-xxl-20"
              name="userName"
              value={formData.upi}
              onChange={handleChange}
              style={{ color: '#5e5e5e' }}
              type="text"
              placeholder="UPI ID is not added"
              disabled
            />
            {errors.upi && <p className="err">{errors.upi}</p>}
          </div>
          <div className=" my-3">
            <button
              onClick={() => {
                setDeleteStatus(false)
                setResetData(true)
              }}
              className="add-button f3  fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 white"
              disabled={!isValidForm}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                minHeight: 48,
                backgroundColor: !isValidForm ? '#9BBFBC' : '#004743',
                border: !isValidForm ? "1px solid #9BBFBC" : "1px solid #004743"
              }}
            >Reset Bank Data
            </button>
          </div>
          <div
            className="QR d-flex ac-jc adjwidthqr"
            style={{ cursor: "pointer", position: "relative" }}
          >
            <div
              onClick={() => {
                setShowPopup(true);
                setShowPopupImage(qrImage);
              }}
              style={{ position: "relative" }}
              className=" mt-2 text-center QRCode_container "
            >
              {qrImage ? (
                <img
                  src={
                    qrImage instanceof File
                      ? URL.createObjectURL(qrImage)
                      : qrImage
                  }
                  alt="QR Preview"
                  style={{
                    width: "150px",
                    height: "150px",
                    borderRadius: "10px",
                    objectFit: "contain",

                  }}
                />
              ) : (
                <>
                  <img
                    src={QR}
                    alt="QR Placeholder"
                    style={{
                      width: "150px",
                      height: "150px",
                      borderRadius: "10px",
                      objectFit: "contain",
                      border: "1.8px dashed #a7a3a3"
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      top: 50,
                      left: 0,
                      right: 0,
                      color: "gray",
                      fontWeight: 600,
                      textAlign: "center"
                    }}
                  >
                    User <br /> QR Code
                  </span>
                </>
              )}
            </div>
          </div>
          <div className=" my-3">
            <button
              onClick={() => {
                setDeleteStatus(true);
                setResetData(true);
              }}
              className="add-button f3  fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 white"
              disabled={!isValidForm2}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                minHeight: 48,
                backgroundColor: !isValidForm2 ? '#9BBFBC' : '#004743',
                border: !isValidForm2 ? "1px solid #9BBFBC" : "1px solid #004743"
              }}
            >Reset QR Code
            </button>
          </div>
          <div style={{ marginTop: 16, marginBottom: 80 }} className="  ">
            <button
              disabled={formData?.status === 2 || formData?.status === 3}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                minHeight: 48,
                backgroundColor: (formData?.status === 2 || formData?.status === 3) ? '#9BBFBC' : '#004743',
                border: (formData?.status === 2 || formData?.status === 3) ? "1px solid #9BBFBC" : "1px solid #004743"
              }}
              onClick={() => { setPopup(true) }}
              className="add-button f3  fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 white"
            >Block User
            </button>
            <button
              onClick={() => { setUnblock(true) }}
              disabled={formData?.status === 1 || formData?.status === 0}
              style={{
                marginTop: 15,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                minHeight: 48,
                backgroundColor: (formData?.status === 1 || formData?.status === 0) ? '#9BBFBC' : '#004743',
                border: (formData?.status === 1 || formData?.status === 0) ? "1px solid #9BBFBC" : "1px solid #004743"
              }}
              className="add-button f3  fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 white"
            >Unblock User
            </button>
          </div>
        </div>
      </CustomScroll>
      {popup && (
        <div className="img-popup-design1">
          <div className="img-popup1">
            {/* Close Button */}
            <button className="close-btn" onClick={() => setPopup(false)}>
              ×
            </button>

            <textarea
              className="input-box3"
              name="block_reason"
              onChange={handleChange}
              placeholder="Type your reason here..."
              value={formData?.block_reason}
              rows="4"
            />

            <div className="d-flex ac-jc px-1 py-1">
              <button
                onClick={() => handleBlock('Blocked')}
                disabled={!formData?.block_reason}
                className="add-button f3  fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19 w-100 "
              >
                {loader ? <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white" }}
                  ></span>
                </> : 'Block User'}
              </button>
            </div>
          </div>
        </div>
      )}
      {Remove && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-15 fs-xxl-19 primary">
              Are you sure, you want to Remove amount from this Client Wallet !
            </p>
            <div style={{ paddingTop: 20 }} className="d-flex ac-jb px-2 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19">
              <button onClick={() => setRemove(false)} className="no-btn w-40">
                No
              </button>
              <button
                onClick={() => handleAddAmount('debit')}
                className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19"
              >
                {load ? <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white" }}
                  ></span>
                </> : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}
      {loading && <Loader />}
      {Addpopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-15 fs-xxl-19 primary">
              Are you sure, you want to Add amount to this Client Wallet !{" "}
            </p>
            <div style={{ paddingTop: 20 }} className="d-flex ac-jb px-2 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19">
              <button onClick={() => setAdd(false)} className="no-btn w-40">
                No
              </button>
              <button
                onClick={() => handleAddAmount('add')}
                className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19"
              >

                {load ? <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white" }}
                  ></span>
                </> : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}
      {UnblockUser && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-15 fs-xxl-19 primary">
              Are you sure, you want to unblock this Client ?
            </p>
            <div style={{ paddingTop: 20 }} className="d-flex ac-jb px-2 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19">
              <button onClick={() => setUnblock(false)} className="no-btn w-40">
                No
              </button>
              <button
                onClick={handleBlock}
                className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19"
              >
                {loader ? <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white" }}
                  ></span>
                </> : 'Confirm'}

              </button>
            </div>
          </div>
        </div>
      )}
      {updateUser && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-15 fs-xxl-19 primary">
              Are you sure, you want to Update ?
            </p>
            <div style={{ paddingTop: 20 }} className="d-flex ac-jb px-2 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19">
              <button onClick={() => setUpdateUser(false)} className="no-btn w-40">
                No
              </button>
              <button
                onClick={handleSubmit}
                className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19"
              >
                {isLoading ? <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white" }}
                  ></span>
                </> : 'Yes'}

              </button>
            </div>
          </div>
        </div>
      )}

      {resetData && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-15 fs-xxl-19 primary">
              {`Are you sure, you want to Delete ${deleteStatus ? 'QR Code' : 'Bank Data'} ?`}
            </p>
            <div style={{ paddingTop: 20 }} className="d-flex ac-jb px-2 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19">
              <button onClick={() => setResetData(false)} className="no-btn w-40">
                No
              </button>
              <button
                onClick={handleDeleteBank}
                className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-15 fs-xxl-19"
              >
                {(deleteStatus ? load : load2) ? <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white" }}
                  ></span>
                </> : 'Yes'}

              </button>
            </div>
          </div>
        </div>
      )}

      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onClick={() => setShowPopup(false)} // close on click outside
        >
          <div
            style={{
              position: "relative",
              maxWidth: "90%",
              maxHeight: "90%",
            }}
            onClick={(e) => e.stopPropagation()} // prevent close when clicking image
          >
            {showPopupImage ? (
              <img
                src={showPopupImage}
                alt="QR Code Popup"
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: 10,
                  boxShadow: "0 0 15px rgba(0,0,0,0.4)",
                }}
              />
            ) : (
              <span style={{ color: "white" }} className="f3">
                QR Not Available
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientReport;
